export function loadDemoDeviceData() {
  return [
    {
      id: '1',
      device_id: 'glucose-monitor-1',
      user_id: 'demo-user-id',
      metric_name: 'blood_glucose',
      metric_value: 120,
      metric_unit: 'mg/dL',
      recorded_at: new Date().toISOString(),
      created_at: new Date().toISOString()
    }
  ];
}
